<template>
	<div class="services"> 
	    <div class="service-content"> 
	        <div :span="8" v-for="(serv, index) in services" :key="index">
	          <div class="service-item">
	            <el-icon class="service-item_icon">
					<component :is="serv.icon"></component>
				</el-icon>
				
	            <h5 class="service-item_title">{{serv.title}}</h5>
	            <p class="service-item_desc">{{serv.description}}</p>
	          </div>
	        </div> 
		</div>
	</div>
</template>

<script setup>
	const services = ref([
        { icon: 'Setting', title: '智能系统', description: '系统依简单、高效、智能化理念设计，更标准的工作流程，更轻松的工作方式，同时带给客户更好的服务体验' },
        { icon: 'Suitcase', title: '自动化设备', description: '使用智能终端、信息化操作台、自动化流水线、打标换标系统等配套智能设备，节约人力成本，提高准确率及操作效率' },
        { icon: 'UserFilled', title: '免费培训', description: '每月1-2次的定期强化培训，提升员工系统思维，平时一对一的培训及客服支持，及时解决系统使用问题，最大化系统使用价值' },
        { icon: 'Cpu', title: '专业研发团队', description: '团队拥有多年互联网+物流行业从业经验，专业的IT技术、熟知物流行业需求，打造不一样的物流系统' },
        { icon: 'DocumentCopy', title: '创新的方案', description: '更科技、更互联网、更创新的物流应用方案和物流解决方案，紧跟信息时代步伐，给客户更好的服务' },
        { icon: 'ChatLineRound', title: '专业持续的支持', description: '我们卖的不是系统，不是设备，卖的是服务，一切服务按需按月付费，永远不会有一手交钱一手交货后无售后的问题' }
    ])
</script>

<style lang="scss" scoped>
	.services {
		font-size: 13px;
		margin-bottom: 1rem;
		padding: 0 30px;
		
		.service-content {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			
			.service-item {
				border: 1px solid #EEEEEE;
				border-radius: 20px;
				color: #666666;
				margin: 1rem;
				padding: 1rem 1rem 1.5rem;
				text-align: center;
				opaticy: 0.1;
				
				.service-item_icon {
					font-size: 3em;
				}
				.service-item_title {
					font-size: 1.25em;
					font-weight: bold;
					margin: 0;
					padding: 1rem;
				}
				.service-item_desc {
					height: 5em;
					line-height: 1.5em;
					padding: 1rem 3.5em;
				}
			}
		}
	}
</style>